(ns common.schema.entities.integration.nylas-token
  (:require [common.schema.entities.integration.nylas-providers :as providers]
            [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/keyword-field :nylas-token/provider
                      "Provider"
                      providers/options
                      {:authorization    su/access-system-user
                       :system-semantics su/system-controlled-optional-field-semantics})
    (su/single-ref-field :nylas-token/account
                         "Account"
                         [:entity.type/account]
                         {:authorization    su/access-system-user
                          :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :nylas-token/email
                          "Email"
                          {:authorization    su/access-system-system
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :nylas-token/token-type
                          "Token type"
                          {:authorization    su/access-system-system
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/datetime-field :nylas-token/connected-on
                       "Connected at"
                       {:authorization    su/access-system-user
                        :system-semantics su/system-controlled-optional-field-semantics})
    (su/datetime-field :nylas-token/expires-on
                       "Expires at"
                       {:authorization    su/access-system-user
                        :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :nylas-token/access-token
                          "Access token"
                          {:authorization    su/access-system-system
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :nylas-token/refresh-token
                          "Refresh token"
                          {:authorization    su/access-system-system
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :nylas-token/id-token
                          "ID token (google)"
                          {:authorization    su/access-system-system
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-edn-field :nylas-token/scopes
                       "Scopes"
                       {:authorization    su/access-system-system
                        :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :nylas-token/nylas-grant-id
                          "Nylas grant ID"
                          {:authorization    su/access-system-system
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :nylas-token/provider-user-id
                          "Provider user ID"
                          {:authorization    su/access-system-system
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/text-simple-field :nylas-token/grant-status
                          "Grant status"
                          {:authorization    su/access-system-user
                           :system-semantics su/system-controlled-optional-field-semantics})
    (su/boolean-field :nylas-token/grant-blocked
                      "Grant blocked"
                      {:authorization    su/access-system-user
                       :system-semantics su/system-controlled-optional-field-semantics}))))
